import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthenticationService } from '../services/http/authentication.service';
import { Router } from '@angular/router';
import { LoggerService } from '../services/behavior/logger.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(
        private alertCtrl: AlertController,
        private authenticationService: AuthenticationService,
        private router: Router,
        private loggerService: LoggerService,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(async (event: HttpEvent<any>) => {
                if (event instanceof HttpResponse && !event.body.success) {
                    const errorMessage = event.body.message;
                    console.error(errorMessage);
                    this.showMessage('ATENÇÃO', errorMessage);
                }
            }),
            catchError((error: HttpErrorResponse) => {
                let errorMessage = '';

                if (error.error?.message) {
                    errorMessage = `${error.error.message}`;

                    switch (error.status) {
                        case 401:
                            errorMessage = 'Não autorizado, por favor autentique-se novamente.';
                            this.authenticationService.logout({ removeDatabaseName: false, removeBaseUrl: false }).then(() => {
                                this.router.navigateByUrl('/login');
                                this.loggerService.warn(() => 'Usuário deslogado devido a erro 401, redirecionando para login.');
                            });
                            break;
                    }
                } else {
                    if (error.status === 0) {
                        errorMessage = 'Não pôde conectar-se ao servidor.';
                    } else {
                        switch (error.status) {
                            case 400:
                                errorMessage = 'Bad request.';
                                break;
                            case 401:
                                errorMessage = 'Não autorizado, por favor autentique-se novamente.';
                                break;
                            case 403:
                                errorMessage = 'Acesso negado.';
                                break;
                            case 404:
                                errorMessage = 'Nenhum dado encontrado.';
                                break;
                            case 409:
                                errorMessage = '';
                                break;
                            case 500:
                                errorMessage = 'Erro do Servidor Interno.';
                                break;
                            default:
                                errorMessage = `Código de erro retornado pelo servidor: ${error.status}, mensagem: ${error.message}`;
                        }
                    }
                }

                //this.showMessage(`ERRO ${error.status} ${error.statusText}`, errorMessage);

                if (errorMessage.length > 0) {
                    this.showMessage('ATENÇÃO', errorMessage);
                    return throwError(() => new Error(errorMessage));
                } else {
                    return throwError(() => new Error('Ocorreu um erro desconhecido.'));
                }
            })
        );
    }

    private async showMessage(title: string, msg: string) {
        if (msg && typeof msg === 'string' && msg.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes('duplicada')) {
            return;
        }

        const alert = await this.alertCtrl.create({
            header: title,
            message: msg,
            buttons: ['OK']
        });

        await alert.present();

        await alert.onWillDismiss();
    }
}
